import { useState, useEffect } from 'react';
import { emailVerificationUtils } from '../utils/pendingProject';
export const useEmailVerificationStatus = (isAuthenticated) => {
    const [isPending, setIsPending] = useState(false);
    useEffect(() => {
        const checkStatus = () => {
            setIsPending(emailVerificationUtils.isPending());
        };
        checkStatus();
        const interval = setInterval(checkStatus, 5000);
        return () => clearInterval(interval);
    }, [isAuthenticated]);
    return isPending;
};
